import { FC } from 'react';

import { NotificationBadge, NotificationBar } from '@crossnokaye/ux-common';

import { AtlasRouteIds } from '@/components/navigation/constants';
import { NavLink } from '@/components/navigation/nav-link';
import { useAlarmActivationsSummary } from '@/hooks/query-hooks/gaia-api/alarm-activations';
import { useCurrentFacility } from '@/hooks/use-current-facility';

export const AlarmBar: FC = () => {
  const { agentId } = useCurrentFacility();

  const { data: alarmActivationsSummary } = useAlarmActivationsSummary({ agentId });

  const { critical, caution, warning } = alarmActivationsSummary ?? {};

  const badges = [
    { id: 'critical', count: critical ?? 0, className: 'bg-ckds-base-critical' },
    { id: 'warning', count: warning ?? 0, className: 'bg-ckds-base-warning text-background' },
    { id: 'caution', count: caution ?? 0, className: 'bg-ckds-base-caution text-background' },
  ].filter((alarm) => alarm.count > 0);

  if (badges.length === 0 || !alarmActivationsSummary) return null;

  return (
    <NotificationBar id={'alarm-notifications'} className={'items-center'}>
      {badges.map(({ id, count, className }) => (
        <NavLink routeId={AtlasRouteIds.Alarms} key={id}>
          <NotificationBadge
            id={id}
            count={count}
            className={className}
            data-cy={`alarm-badge-${id}`}
          />
        </NavLink>
      ))}
    </NotificationBar>
  );
};
